"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAuthState = exports.useAuthDispatch = exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@xstate/react");
var _AuthMachine = _interopRequireDefault(require("../../machines/AuthMachine"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const {
  machine: authMachine
} = _AuthMachine.default;
const StateContext = /*#__PURE__*/(0, _react.createContext)();
const DispatchContext = /*#__PURE__*/(0, _react.createContext)(() => {});
const Provider = /*#__PURE__*/(0, _react.memo)(_ref => {
  let {
    children,
    apiBaseUrl = "https://resource-platform-api.oneclass.com.tw",
    productApiUrl = "https://resource-library-api-dev.oneclass.com.tw"
  } = _ref;
  const [state, send] = (0, _react2.useMachine)(authMachine, {
    context: {
      apiBaseUrl,
      productApiUrl
    }
  });
  console.log(state);
  return /*#__PURE__*/_react.default.createElement(StateContext.Provider, {
    value: state
  }, /*#__PURE__*/_react.default.createElement(DispatchContext.Provider, {
    value: send
  }, children));
});
const useAuthState = () => (0, _react.useContext)(StateContext);
exports.useAuthState = useAuthState;
const useAuthDispatch = () => (0, _react.useContext)(DispatchContext);

// const useAuth = () => {
// 	const dispatch = useAuthDispatch();

// 	const logout = () => dispatch({ type: "" });

// 	// const event = useMemo(() => ({
// 	// 	logout,
// 	// }));

// 	return {
// 		logout,
// 	};
// };
exports.useAuthDispatch = useAuthDispatch;
var _default = exports.default = Provider;
Provider.propTypes = {
  children: _propTypes.default.node,
  apiBaseUrl: _propTypes.default.string,
  productApiUrl: _propTypes.default.string
};